var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      staticClass: "mural-drawer__backdrop",
      on: {
        click: function ($event) {
          return _vm.$emit("close")
        },
      },
    }),
    _c("div", { staticClass: "mural-drawer" }, [
      _c(
        "div",
        {
          staticClass: "mural-drawer__head",
          style: { background: _vm.tintColor, borderBottomColor: _vm.color },
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center", staticStyle: { gap: ".6rem" } },
            [
              _c(
                "b-badge",
                {
                  style: { background: _vm.color, color: "#fff" },
                  attrs: { pill: "" },
                },
                [_vm._v(_vm._s(_vm.lesson.modality_name))]
              ),
              _c(
                "b-badge",
                { attrs: { pill: "", variant: _vm.statusVariant } },
                [_vm._v(_vm._s(_vm.$t("mural.status." + _vm.status)))]
              ),
              _c("span", { staticClass: "flex-grow" }),
              _c("feather-icon", {
                staticClass: "cursor-pointer",
                attrs: { icon: "XIcon", size: "20" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          ),
          _c("h3", { staticClass: "mural-drawer__title" }, [
            _vm._v(_vm._s(_vm.lesson.name)),
          ]),
          _c("div", { staticClass: "mural-drawer__when" }, [
            _vm._v(
              _vm._s(_vm.dateLabel) +
                " · " +
                _vm._s(_vm.slot.startTime) +
                " – " +
                _vm._s(_vm.slot.endTime)
            ),
          ]),
          _vm.showTicketReport
            ? _c(
                "button",
                {
                  staticClass: "mural-drawer__ticket-link",
                  attrs: { type: "button" },
                  on: { click: _vm.goToTicketReport },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-25",
                    attrs: { icon: "CheckSquareIcon", size: "13" },
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("mural.actions.ticket_report")) + " "
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "mural-drawer__body" }, [
        _c("div", { staticClass: "mural-drawer__cols" }, [
          _c("div", [
            _c("div", { staticClass: "mural-drawer__caption" }, [
              _vm._v(_vm._s(_vm.$t("mural.drawer.teacher"))),
            ]),
            _c(
              "div",
              {
                staticClass: "flex items-center",
                staticStyle: { gap: ".5rem" },
              },
              [
                _c("feather-icon", {
                  staticClass: "text-primary",
                  attrs: { icon: "UserIcon", size: "16" },
                }),
                _c("span", { staticClass: "mural-drawer__strong" }, [
                  _vm._v(_vm._s(_vm.teacherName)),
                ]),
              ],
              1
            ),
          ]),
          _vm.lesson.rental_space
            ? _c("div", [
                _c("div", { staticClass: "mural-drawer__caption" }, [
                  _vm._v(_vm._s(_vm.$t("mural.drawer.space"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "flex items-center",
                    staticStyle: { gap: ".5rem" },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "text-danger",
                      attrs: { icon: "MapPinIcon", size: "16" },
                    }),
                    _c("span", { staticClass: "mural-drawer__strong" }, [
                      _vm._v(_vm._s(_vm.lesson.rental_space)),
                    ]),
                  ],
                  1
                ),
              ])
            : _c("div", [
                _c("div", { staticClass: "mural-drawer__caption" }, [
                  _vm._v(_vm._s(_vm.$t("mural.drawer.capacity_source"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "flex items-center",
                    staticStyle: { gap: ".5rem" },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "text-warning",
                      attrs: { icon: "SlidersIcon", size: "16" },
                    }),
                    _c("span", { staticClass: "mural-drawer__strong" }, [
                      _vm._v(_vm._s(_vm.capacitySourceLabel)),
                    ]),
                  ],
                  1
                ),
              ]),
        ]),
        _c("div", { staticClass: "mt-2" }, [
          _c(
            "div",
            { staticClass: "flex justify-between items-baseline mb-25" },
            [
              _c("span", { staticClass: "mural-drawer__caption mb-0" }, [
                _vm._v(_vm._s(_vm.$t("mural.drawer.occupancy"))),
              ]),
              _c("span", { staticClass: "mural-drawer__strong" }, [
                _vm._v(_vm._s(_vm.occupancyText)),
              ]),
            ]
          ),
          _c("div", { staticClass: "mural-drawer__track" }, [
            _c("div", {
              style: { width: _vm.percent + "%", background: _vm.color },
            }),
          ]),
          _c("div", { staticClass: "text-muted mt-25" }, [
            _c("small", [
              _vm._v(_vm._s(_vm.freeText) + " · " + _vm._s(_vm.mixText)),
            ]),
          ]),
        ]),
        _vm.slot.reason
          ? _c("div", { staticClass: "mural-drawer__note" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("mural.drawer.reason")) + ":"),
              ]),
              _vm._v(" " + _vm._s(_vm.slot.reason) + " "),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "mt-2" },
          [
            _c(
              "div",
              { staticClass: "flex justify-between items-center mb-50" },
              [
                _c("span", { staticClass: "mural-drawer__caption mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("mural.drawer.students"))),
                ]),
                _c(
                  "b-badge",
                  { attrs: { variant: "light-secondary", pill: "" } },
                  [_vm._v(_vm._s(_vm.slot.students.length))]
                ),
              ],
              1
            ),
            !_vm.slot.students.length && !_vm.grants.length
              ? _c("div", { staticClass: "text-muted py-1" }, [
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("mural.drawer.no_students"))),
                  ]),
                ])
              : _vm._e(),
            _vm._l(_vm.slot.students, function (student) {
              return _c(
                "div",
                {
                  key: student.scheduled_event_id,
                  staticClass: "mural-drawer__student",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "mural-drawer__avatar",
                      style: _vm.toneStyle(student.name),
                    },
                    [_vm._v(_vm._s(_vm.initialsOf(student.name)))]
                  ),
                  _c("div", { staticClass: "mural-drawer__student-main" }, [
                    _c("div", { staticClass: "mural-drawer__student-name" }, [
                      _vm._v(_vm._s(student.name)),
                    ]),
                    student.gate_check_in
                      ? _c(
                          "div",
                          { staticClass: "mural-drawer__gate" },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-25",
                              attrs: { icon: "CheckSquareIcon", size: "11" },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("mural.checkin.gate_entry", {
                                    time: student.gate_check_in.at,
                                    channel:
                                      student.gate_check_in.channel_label,
                                  })
                                ) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-muted" }, [
                          _c("small", [_vm._v(_vm._s(student.email))]),
                        ]),
                  ]),
                  _c(
                    "b-badge",
                    {
                      staticClass: "mural-drawer__tag",
                      attrs: {
                        variant: _vm.originVariant(student.origin),
                        pill: "",
                      },
                    },
                    [_vm._v(" " + _vm._s(student.origin_label || "—") + " ")]
                  ),
                  _c("feather-icon", {
                    class:
                      student.status === "DO" ? "text-success" : "text-warning",
                    attrs: {
                      icon:
                        student.status === "DO"
                          ? "CheckCircleIcon"
                          : "ClockIcon",
                      size: "15",
                    },
                  }),
                ],
                1
              )
            }),
            _vm._l(_vm.grants, function (grant) {
              return _c(
                "div",
                { key: "g-" + grant.id, staticClass: "mural-drawer__student" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "mural-drawer__avatar",
                      style: _vm.toneStyle(grant.user_name),
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.initialsOf(grant.user_name)) + " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "mural-drawer__student-main" }, [
                    _c("div", { staticClass: "mural-drawer__student-name" }, [
                      _vm._v(_vm._s(grant.user_name)),
                    ]),
                    _c("div", { staticClass: "text-muted" }, [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.$t("mural.drawer.granted")) +
                            " · " +
                            _vm._s(grant.scope_label)
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "b-badge",
                    {
                      staticClass: "mural-drawer__tag",
                      attrs: { variant: "light-warning", pill: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("mural.actions.grant")) + " ")]
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
      _vm.showActions
        ? _c(
            "div",
            { staticClass: "mural-drawer__foot" },
            [
              _vm.can.checkin
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "success", block: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("action", "checkin")
                        },
                      },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "UserCheckIcon", size: "16" },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("mural.actions.checkin")) + " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mural-drawer__grid" },
                [
                  _vm.can.reschedule
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("action", "reschedule")
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25",
                            attrs: { icon: "CalendarIcon", size: "15" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("mural.actions.reschedule")) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.can.edit
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-warning" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("action", "capacity")
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25",
                            attrs: { icon: "UsersIcon", size: "15" },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("mural.actions.capacity")) + " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.can.grant
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("action", "grant")
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25",
                            attrs: { icon: "UserPlusIcon", size: "15" },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("mural.actions.grant")) + " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.can.edit
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-dark" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit(
                                "action",
                                _vm.slot.blocked ? "unblock" : "block"
                              )
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25",
                            attrs: {
                              icon: _vm.slot.blocked
                                ? "UnlockIcon"
                                : "SlashIcon",
                              size: "15",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.slot.blocked
                                  ? _vm.$t("mural.actions.unblock")
                                  : _vm.$t("mural.actions.block")
                              ) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.can.cancel
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "flat-secondary",
                        size: "sm",
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("action", "cancel")
                        },
                      },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-25",
                        attrs: { icon: "XCircleIcon", size: "14" },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("mural.actions.cancel")) + " "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }